import { render, staticRenderFns } from "./UiDialogEditPwd.vue?vue&type=template&id=a19e7136&scoped=true"
import script from "./UiDialogEditPwd.vue?vue&type=script&lang=ts"
export * from "./UiDialogEditPwd.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a19e7136",
  null
  
)

export default component.exports